import React, {Component} from "react";
import SecureLayout from "./../../../templates/secure";
import _ from 'lodash';

class UsersSearch extends Component {
	render() {
		const { roles, status, users } = this.props;
		return <div className="field has-addons">
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._clearSearch}>
					&nbsp;&nbsp;
					<span className="icon is-small">
						<i className="fa fa-ban"/>
					</span>
				</a>
			</div>

			<div className="control">
				<div className="select is-small">
					<select name="role_id" id="role_id" value={users.filters.role_id} onChange={this._roleChange}>
						<option value="">--- Perfil ---</option>
						{_.map(roles.list, (row, k) => {
							return (
								<option key={k} value={row.id}>{row.display ? row.display:row.name}</option>
							)
						})}
					</select>
				</div>
			</div>

			<div className="control">
				<div className="select is-small">
					<select id="status_id" name="status_id" value={users.filters.status_id} onChange={this._statusChange}>
						<option value=" ">--- Estatus ---</option>
						{_.map(status.data, (stat, k) => {
							return <option value={stat.id} key={k}>{stat.name}</option>
						})}
					</select>
				</div>
			</div>

			<div className="control">
				<input className="input is-small" type="search" ref="q" id="q" placeholder="Buscar" value={users.filters.q} onChange={this._searchChange}/>
			</div>
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._submitSearch}>Buscar</a>
			</div>
		</div>
	}

    constructor() {
        super();
        this._submitSearch = this._submitSearch.bind(this);
        this._searchChange = this._searchChange.bind(this);
	    this._roleChange = this._roleChange.bind(this);
	    this._statusChange = this._statusChange.bind(this);
	    this._clearSearch = this._clearSearch.bind(this);
    }

    _submitSearch() {
        //this.props.usersList(1, null, {q: ref.value});
	    const {users} = this.props;
	    this.props.usersList(1,users.filters);
    }

	_searchChange(event){
		/*this.setState({
			q:event.target.value
		});*/
		this.props.change('users.filters.q',event.target.value);
	}

	_statusChange(event){
		//console.log('status==>', event.target.value)
		/*this.setState({
			status_id:event.target.value
		});*/
		this.props.change('users.filters.status_id',event.target.value);
	}

	_roleChange(event){
		/*this.setState({
			role_id:event.target.value
		});*/
		this.props.change('users.filters.role_id',event.target.value);
	}

	_clearSearch(){
		this.props.reset('users.filters');
		this.props.usersList(1);
	}
}

export default SecureLayout(UsersSearch);



// WEBPACK FOOTER //
// ./src/elements/users/widget/users_search.jsx